import template from './link-to-license-renewal-form.html';

export default {
  controller: 'LinkToLicenseRenewalFormController',
  template,
  bindings: {
    retailerId: '<',
  },
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/components/link-to-license-renewal-form/link-to-license-renewal-form-component.js